import { Asset } from 'contentful';
import { ReactElement } from 'react';
import { IFragmentInsuranceFields } from 'types/contentful';
import PhotoGalleryBlock from './PhotoGalleryBlock';

interface InsuranceProvidersProps {
  insuranceProviders: IFragmentInsuranceFields[];
  insuranceDisclaimer?: string;
  insuranceSlug?: string;
}

export default function InsuranceProviders({
  insuranceProviders,
  insuranceDisclaimer,
  insuranceSlug,
}: InsuranceProvidersProps): ReactElement {
  console.log({ insuranceSlug });
  return (
    <div className="ecp-my py-10 md:py-20 px-site-component">
      <h2 className="font-heading text-2xl md:text-4xl text-center mb-16">Accepted Insurances</h2>
      <div className="flex flex-wrap my-2 mx-auto">
        {insuranceProviders
          ?.filter((item) => item.image !== undefined)
          .map((item, i) => (
            <PhotoGalleryBlock key={i} image={item.image as Asset} query="w=450" width={5} />
          ))}
      </div>

      {insuranceDisclaimer && (
        <div className="mt-3 bg-neutral text-lg p-3 w-full md:flex md:justify-center md:text-center hidden md:mt-10 md:mb-8 mx-auto">
          {insuranceDisclaimer}
        </div>
      )}
    </div>
  );
}
